import { __ } from '@wordpress/i18n';

export const UpgradePro = ({ updateProgress, WizardFooter }) => {
    const { imageUrl } = window['jkitWizard'];

    return <div className="upgrade-pro-wrapper">
        <div className="upgrade-pro-content">
            <img className="banner background" src={imageUrl + '/pro-banner-gradient-bg.png'} />
            <img className="banner pattern" src={imageUrl + '/pro-banner-pattern-bg.png'} />
            <img className="banner center" src={imageUrl + '/pro-banner-images.png'} />
            <img className="banner item arrow" src={imageUrl + '/wizard-arrow.png'} />
            <h3 className="content-title">
                {__('Unlock & Power Up Your Website with ', 'jkit')}
                <span className="gradient-text">{__('JEG KIT PRO', 'jkit')}</span>
            </h3>
            <p className="content-desc">
                {__('Empowering you to build a website that truly stands out with advanced features and seamless integration.', 'jkit')}
            </p>
            <div className="upgrade-pro-button" onClick={() => window.open('https://jegkit.com/pricing/?utm_source=jeg-elementor-kit&utm_medium=wizard', '_blank')}>
                <div className="button-content-wrapper">
                    <span>{__('Upgrade To PRO', 'jkit')}</span>
                    <svg width={16} height={16} viewBox="0 0 15 15" fill={'white'} transform={'translate(0,0)'} xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.25 9.5L2 2.625L5.4375 5.75L7.625 2L9.8125 5.75L13.25 2.625L12 9.5H3.25ZM12 11.375C12 11.75 11.75 12 11.375 12H3.875C3.5 12 3.25 11.75 3.25 11.375V10.75H12V11.375Z" fill={'white'} />
                    </svg>
                </div>
            </div>
        </div>
        <div className="wizard-actions">
            <WizardFooter updateProgress={updateProgress} next={{progress:'done', step: 3}}  back={{progress:'importDemo', step: 1}} />
        </div>
    </div>;
};
